import { z } from 'zod'
import { useSyncedState } from './useSyncedState'
import { useSetMultipleSearchParams } from './useSetMultipleSearchParams'

const VIEW_SCHEMA = z.enum(['channels', 'groups'])
export type ContributionView = z.infer<typeof VIEW_SCHEMA>

/** URL-synced Contribution view (#13). Switching applies the new view's PRESET: the KPI-cascade
 *  and Group-by URL params are cleared in the SAME atomic write (their per-view seeds then
 *  apply); dim filters, timeframe, and granularity deliberately survive — the views are two
 *  decomposition lenses over the same fact (spec §4.3). */
export function useContributionView(): [ContributionView, (next: ContributionView) => void] {
  const [view] = useSyncedState('view', VIEW_SCHEMA, 'url', 'channels')
  const setMultiple = useSetMultipleSearchParams()
  const switchView = (next: ContributionView) => {
    if (next === view) return
    setMultiple({
      view: next,
      kpi_root: null,
      kpi_driver: null,
      kpi_value_type: null,
      groupby: null,
    })
  }
  return [view, switchView]
}
